<angular-slickgrid
  [gridId]="gridId()"
  [columns]="columnDefinitions()"
  [options]="gridOptions"
  [dataset]="dataset()"
  (onGridCreated)="gridReady($event)"
  (onAngularGridCreated)="onAngularGridReady($event)"
>
</angular-slickgrid>